import * as React from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { Box, TextInput, Switch, Group, Button, Textarea, NumberInput } from '@mantine/core'
import { useForm, isNotEmpty } from "@mantine/form";
import axios from 'axios';
import { CLIENT_ROUTE, API_ROUTE, CLIENT_TITLE } from "./constants";
import { showMessage } from "../../lib/notification";
import { DatePicker } from "@mantine/dates";
import type { IResponse } from "../../types/api";
import type { ISongGroup } from "./types";
import dayjs from "dayjs";
import Page from "../../components/layout/Page";

interface FormValues extends Pick<ISongGroup, 'groupNumber' | 'addedDate' | 'groupTitle' | 'description' | 'addedYear' | 'addedMonth' | 'isActive'> {
}

interface IParams extends Pick<ISongGroup, 'addedDate' | 'groupNumber' | 'description'> {
}

const EditSongGroup = () => {

    const { state: id = null } = useLocation();

    const navigate = useNavigate();

    const form = useForm<FormValues>({
        initialValues: {
            addedDate: '',
            addedMonth: 0,
            addedYear: 0,
            description: '',
            groupNumber: 0,
            groupTitle: '',
            isActive: false
        },

        validate: {
            addedDate: isNotEmpty('Харгалзах өдөр оруулна уу'),
            groupNumber: isNotEmpty('Бүлгийн дугаар оруулна уу'),
        },
    });

    React.useEffect(() => {
        const fetchData = async () => {
            const { data } = await axios.get<IResponse<ISongGroup>>(`${API_ROUTE}/${id}`);
            form.setValues(data.result);
            form.resetDirty();
        }
        void fetchData();
    }, []);

    const handleSubmit = async (values: typeof form.values) => {
        const bodyParam: IParams = {
            ...values,
            addedDate: dayjs(values.addedDate).format('YYYY-MM-DD'),
        }
        const { data } = await axios.post<IResponse<any>>(`${API_ROUTE}/${id}`, bodyParam);

        if (data.statusCode === 200) {
            navigate(CLIENT_ROUTE);
            showMessage('Амжилттай', 'green');
        } else {
            showMessage('Алдаа гарлаа',);
        }
    }

    return (
        <Page>
            <Page.Header title={`${CLIENT_TITLE} засах`} backRoute={CLIENT_ROUTE}/>
            <Page.Body>
                <Box sx={{ maxWidth: 500 }} mx="auto">
                    <form onSubmit={form.onSubmit(handleSubmit)}>
                        <NumberInput
                            withAsterisk
                            disabled
                            label="Бүлгийн дугаар"
                            placeholder="Бүлгийн дугаар"
                            {...form.getInputProps('groupNumber')}
                        />

                        <DatePicker
                            disabled
                            withAsterisk
                            placeholder="Харгалзах өдөр"
                            label="Харгалзах өдөр"
                            {...form.getInputProps('addedDate')}
                        />

                        <TextInput
                            withAsterisk
                            disabled
                            label='Гарчиг'
                            placeholder='Гарчиг'
                            {...form.getInputProps('groupTitle')}
                        />

                        <Textarea
                            label="Тайлбар"
                            placeholder="Тайлбар..."
                            {...form.getInputProps('description')}
                        />

                        <NumberInput
                            disabled
                            label="Нэмэгдсэн он"
                            placeholder="Нэмэгдсэн он оруулна уу"
                            {...form.getInputProps('addedYear')}
                        />

                        <NumberInput
                            disabled
                            label="Нэмэгдсэн сар"
                            placeholder="Нэмэгдсэн сар оруулна уу"
                            {...form.getInputProps('addedMonth')}
                        />

                        <Switch
                            label="Идэвхтэй эсэх"
                            {...form.getInputProps('isActive', { type: 'checkbox' })}
                        />

                        <Group position="right" mt="md">
                            <Button type="submit" color='color-secondary'>Хадгалах</Button>
                        </Group>
                    </form>
                </Box>
            </Page.Body>
            <Page.Footer>
                <Group position="right" mt="md">
                    <Button color='color-secondary' onClick={() => form.onSubmit(handleSubmit)()}>Хадгалах</Button>
                </Group>
            </Page.Footer>
        </Page>
    );
};

export default EditSongGroup;